function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

class addtoCartComponent extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");
    this.submitBtn = this.form.querySelectorAll('button[name="add"]');
    this.qtyButtons = this.form.querySelectorAll(".o-qtyControls-button");
    this.qtyInput = this.form.querySelector("input[name='quantity']");
    this.qtyIndicator = this.form.querySelector(
      ".o-qtyControls-indicator .js-qty-indicator"
    );
    this.variantSizeSelect = this.form.querySelector("select.product-select");
    this.productPrice = document.querySelector(
      ".js-product-details .js-price-preview"
    );
    this.carouselImages = document.querySelectorAll('.product-thumbnails .product-thumb-item');
  }

  connectedCallback() {
    this.submitBtn.forEach((elm) =>
      elm.addEventListener("click", this.submitFormAction.bind(this))
    );

    this.qtyButtons.forEach((elm) =>
      elm.addEventListener("click", this.updateQuantity.bind(this))
    );

    this.variantSizeSelect.addEventListener(
      "change",
      this.updateVariant.bind(this)
    );
  }

  updateQuantity(evt) {
    const targetAction = evt.target.closest(".o-qtyControls-button").dataset
      .action;

    if (targetAction === "plus") {
      this.qtyInput.value = parseInt(this.qtyInput.value) + 1;
      this.qtyIndicator.textContent = this.qtyInput.value;
    }
    if (targetAction === "minus") {
      if (this.qtyInput.value <= 1) return;

      this.qtyInput.value = parseInt(this.qtyInput.value) - 1;
      this.qtyIndicator.textContent = this.qtyInput.value;
    }
  }

  updateVariant(evt) {
    console.log('update variante')
    console.log(evt)
    this.variantType = evt.target.dataset.variantType;
    this.variantInput = this.form.querySelector(
      `input[name='${this.variantType}']`
    );
    this.variantPrice = this.variantSizeSelect.querySelector(
      `option[value='${evt.target.value}']`
    ).dataset.variantPrice;
    this.variantCompareAtPrice = this.variantSizeSelect.querySelector(
      `option[value='${evt.target.value}']`
    ).dataset.variantCompareAtPrice;

    this.available = this.variantSizeSelect.querySelector(
      `option[value='${evt.target.value}']`
    ).dataset.available;
   
    if(this.variantInput){
      this.variantInput.value = evt.target.value;
    }
    
    this.updateProductPrice(this.variantPrice, this.variantCompareAtPrice);
    this.updateProductImage(evt.target.value);
  }

  updateProductImage(selectedVariant) {
    const selectedOption = this.variantSizeSelect.querySelector(
      `option[value='${selectedVariant}']`
    );
  
    const selectedImage = selectedOption.dataset.image;
  
    if (!selectedImage) {
      return;
    }
  
    this.carouselImages.forEach(image => {
      if (image.dataset.image === selectedImage) {
        image.click();
      }
    });
  }
  

  updateProductPrice(price, compareAtPrice) {
    const formattedPrice = price.replace("$", "");
    const formattedCompareAtPrice = compareAtPrice.replace("$", "");
    const formattedPriceInt = parseFloat(formattedPrice);
    const formattedCompareAtPriceInt = parseFloat(formattedCompareAtPrice);
    let currentcurrency = document.querySelector('input.currentcurrency').value;
    if(currentcurrency == 'USD') {
      this.productPrice.innerHTML = ``;
    }
  
    if (formattedCompareAtPriceInt > 0 && formattedCompareAtPriceInt > formattedPriceInt) {
      this.productPrice.innerHTML += `<del>${compareAtPrice}</del>`;
    }
  
    if (formattedPriceInt > 0) { 
      this.productPrice.innerHTML += `<div class="Product-price-box">${price}</div>`;
    }
  
    if (formattedCompareAtPriceInt > 0 && formattedPriceInt < formattedCompareAtPriceInt) {
      this.productPrice.innerHTML += `<span class="Product-price-save"><strong class="Product-price-save-content">Save ${(
        ((formattedCompareAtPriceInt - formattedPriceInt) /
          formattedCompareAtPriceInt) *
        100
      ).toFixed(0)}%</strong></span>`;
    }
  
    if (this.available == 'false') {
      this.productPrice.innerHTML += `<span class="Product-price-save"><strong class="Product-price-save-content">SOLD OUT</strong></span>`;
    }
    
    
    /*
    if (price === compareAtPrice) {
      this.productPrice.innerHTML = `<div class="Product-price-box">${price}</div>`;
    } else {
      this.hasDiscount = this.productPrice.querySelector("del");

      if (this.hasDiscount) {
        this.productPrice.querySelector("del").textContent = compareAtPrice;
        this.productPrice.querySelector(".Product-price-box").textContent =
          price;
      } else {
        const formattedPrice = price.replace("$", "");
        const formattedCompareAtPrice = compareAtPrice.replace("$", "");
        console.log({
          formattedPrice,
          formattedCompareAtPrice
        })
        this.productPrice.innerHTML = `<del>${compareAtPrice}</del><div class="Product-price-box">${price}</div><span class="Product-price-save"><strong class="Product-price-save-content">Save ${(
          ((formattedCompareAtPrice - formattedPrice) /
            formattedCompareAtPrice) *
          100
        ).toFixed(0)}%</strong></span>`;
        
      }
    }
    */
  }

  submitFormAction(evt) {
    evt.preventDefault();

    this.submitBtn.forEach((elm) => elm.classList.add("loading"));

    const form = this.form;
    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    config.body = JSON.stringify({
      ...JSON.parse(serializeForm(form)),
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch("/cart/add", config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          response.status == 422
            ? alert(`No more stock`, `${response.description}`)
            : "";
          console.log("Product adding to cart failed", response.status);
          return;
        }

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.querySelector(`#${section.id} ${section.selector}`) ||
            document.getElementById(section.id);

          if (!elementToReplace) return;

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            response.sections[section.section],
            section.selector
          );
        });

        this.submitBtn.forEach((elm) => elm.classList.remove("loading"));
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  showCartDrawer() {
    this.cartDrawer = document.querySelector("#cart-drawer");
    this.overlaycartDrawer = document.querySelector(".overlay__cart-drawer");
    this.cartDrawer.classList.add("show");
    this.overlaycartDrawer.classList.add("show");
    document.body.style.overflow = "hidden";
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        section: document.getElementById("cart-drawer").dataset.id,
        selector: ".form__cart-drawer",
      },
      {
        id: "Header-icon",
        section: "header",
        selector: "#Header-icon",
      },
    ];
  }
}
customElements.define("product-formadd", addtoCartComponent);
